import { connect } from 'react-redux';
import { stateCurrentName } from '@Selectors/StateCurrentSelectors';
import { userName, isShibbolethUser } from '@Containers/Header/HeaderComponentSelectors';
import {
  getRouterHref as getRouterHrefAction,
  goToRouterState as goToRouterStateAction,
  openLogoutDialog as openLogoutDialogAction,
} from '@Containers/Header/HeaderComponentActions';
import { paths } from '@AppRoutes/constants';
import PropTypes from 'prop-types';
import NamedUser from './NamedUser';

function NamedUserContainer(props) {
  const { goToRouterState } = props;

  const userLinkHandler = () => {
    goToRouterState(paths.PROFILE);
  };

  return <NamedUser {...props} userLinkHandler={userLinkHandler} />;
}

function mapStateToProps(state) {
  return {
    stateCurrentName: stateCurrentName(state),
    userName: userName(state),
    isShibbolethUser: isShibbolethUser(state),
  };
}

const mapDispatchToProps = {
  getRouterHref: getRouterHrefAction,
  goToRouterState: goToRouterStateAction,
  openLogoutDialog: openLogoutDialogAction,
};

NamedUserContainer.propTypes = {
  goToRouterState: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(NamedUserContainer);
